import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Japanese%20female%20celebrity%20elegant%20artistic%20portrait%20in%20flowing%20fabric%20with%20soft%20dramatic%20lighting%2C%20minimal%20dark%20background%20with%20subtle%20gold%20accents%2C%20ethereal%20and%20sophisticated%20atmosphere%2C%20editorial%20fashion%20photography%20style%2C%20warm%20ambient%20tones%2C%20professional%20high-end%20composition&width=1800&height=1000&seq=yutamaki-hero-01&orientation=landscape"
        alt="友田真希 - 官方粉丝应援"
        title="友田真希 官方粉丝应援"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <p className="text-white/70 text-xs md:text-sm tracking-[0.3em] uppercase mb-4 font-label animate-fadeIn">
          Official Fan Support Site
        </p>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-wide animate-slideUp">
          友田真希
        </h1>
        <p className="text-white/80 text-sm md:text-lg max-w-xl leading-relaxed mb-8 animate-slideUp" style={{ animationDelay: '0.15s' }}>
          汇聚最新动态、作品资讯与粉丝应援资源，<br className="hidden md:block" />
          走进友田真希的艺能世界
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 animate-slideUp" style={{ animationDelay: '0.3s' }}>
          <Link
            to="/category/latest"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap"
          >
            探索最新动态
          </Link>
          <Link
            to="/category/works"
            className="px-8 py-3 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white text-sm font-medium rounded-full transition-all duration-300 whitespace-nowrap"
          >
            浏览作品集锦
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-5 h-8 border-2 border-white/40 rounded-full flex items-start justify-center p-1">
          <div className="w-1 h-2 bg-white/60 rounded-full animate-scrollBounce"></div>
        </div>
      </div>
    </section>
  );
}